import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { ChevronArrow } from "./ChevronArrow";
export const CollapseChevron = props => {
    const { className, containerClassName, collapsed, size = 16 } = props;
    return (_jsx("div", { className: clsx("p-2 rounded-full hover:bg-opacity-30 hover:bg-black", containerClassName), children: _jsx(ChevronArrow, { direction: collapsed ? "down" : "up", className: className, size: size }) }));
};
